import React from 'react'
import './component.css'
export default function Education() {
  return (
    <div  id="Education" className='mainEdu'>
        
       <div className="EduTilte">
       <br/>
       Qualification 
       </div>
        <br/>
    <div className='mainEduCard'>
      <table className='eduTable'>
        <tr>
            <td>
                <div className='eCard'>
                <label><h4>10th Boards | SSC</h4></label>
                <p>S.S. Highschool , Nesari</p>
                </div> 
            </td>
            <td><div className='vl'/><div className='ci1'></div></td>
            <td></td>
        </tr>
        <tr style={{padding:0}}>
            <td></td>
            <td><div className='vl'/><div className='ci2'></div></td>
            <td style={{paddingLeft:10}}>
                <div className='eCard'>
                <label><h4>12th Boards | HSC | PCM</h4></label>
                <p>Sai International Jr. College , 7993+5WQ , Shendri, Gadinglaj</p>
                </div>
            </td>
        </tr>
        <tr style={{padding:0}}>
            <td>
                <div className='eCard'>
                <label><h4>B-Tech | Computer Engineering</h4></label>
                <p>PCCOE - Pimpri Chinchwad College of Engineering ,Nigdi,Pune</p>
                </div> 
            </td>
            <td><div className='vl'/><div className='ci3'></div></td>
            <td></td>
        </tr>
      </table>
    </div>
    </div>
  )
}

   